const QUERIES = {
  USERS_LIST: 'users-list',
  ELEMENTS_LIST: 'elements-list'
}

export { QUERIES }
